import axios from 'axios';
import { MDBBtn } from 'mdb-react-ui-kit';
import React,{useState, useRef} from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUpload } from "@fortawesome/free-solid-svg-icons";

import { backendPathCustomers, backendPathEmployees } from '../Constants';
import "../App.css";


function Uploader(props) {
    const [selectedFiles, setSelectedFiles] = useState([]);
    const inputRef = useRef(null);

    
    const onFileChange = event => {
        setSelectedFiles(event.target.files);
    };
    
    const onFileUpload = () => {
    
        const formData = new FormData();

        if (props.personType==="employee") {
            formData.append('employeeId', props.personalId);
        }
        else {
            formData.append('customerId', props.personalId);
        }
        
        for (let i=0; i<selectedFiles.length; i++) {
            formData.append("file"+String(i), selectedFiles[i]);
        }
        formData.append('amount', selectedFiles.length);

        console.log(formData);
        console.log(selectedFiles);

        const uploadPath = props.personType==="employee" ? backendPathEmployees+`upload-employee-file.php` : backendPathCustomers+`upload-customer-file.php`;
        axios.post(uploadPath , formData,{
            headers: {
            'content-type': 'multipart/form-data'
            }
        }).then((response) => {
            console.log(response);
            setSelectedFiles([]);
            inputRef.current.value = null;
            props.refresh();
        });
    };
    

    return(
        <div>
            <div className='file-upload-container'>
                <input className="form-control" type="file" id="formFileMultiple" ref={inputRef} multiple onChange={onFileChange}/>
                {
                    selectedFiles.length ? 
                    <MDBBtn className="btn right-btn" onClick={onFileUpload}>
                        <FontAwesomeIcon className='btn-icon' icon={faUpload} />
                        Hochladen
                    </MDBBtn>
                    :
                    <MDBBtn className="btn-disabled right-btn" disabled>
                        <FontAwesomeIcon className='btn-icon' icon={faUpload} />
                        Hochladen
                    </MDBBtn>
                }
            </div>
        </div>
    );
    
  }
  
  export default Uploader;